import React from 'react';
import { Form, Select, InputNumber, Checkbox, Row, Col, Card, Button, Divider } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { SINISTER_COLORS } from '../../../../../components/ui/colors';
import { displayNumbers } from '../../../../../variables/numbersFunctions';
import VictimesSection from '../VictimesSection';

const { Option } = Select;

const VictimesStep = ({
    typeSinistre, garanties, evaluationInitiale, setEvaluationInitiale,
    victimes, setVictimes, autoVictimes, professions, selectedContratObj, adversaires,
    selectedGaranties, setSelectedGaranties, calculateEvaluation,
}) => (
    <Card style={{ borderRadius: 16, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <div style={{ background: SINISTER_COLORS.primary, padding: '10px 30px', margin: '-24px -24px 24px -24px', borderRadius: '6px 6px 0 0' }}>
            <h2 style={{ color: '#fff', margin: 0, fontSize: 20, fontWeight: 'bold' }}>
                <SafetyOutlined style={{ marginRight: 12 }} />Victimes & Évaluation
            </h2>
        </div>

        {/* Garanties */}
        <div style={{ background: 'linear-gradient(135deg, #e1f5fe 0%, #b3e5fc 100%)', padding: 16, borderRadius: 12, marginBottom: 20 }}>
            <h4 style={{ color: '#01579b', marginBottom: 16 }}>🛡️ Garanties affectées</h4>
            <Form.Item label={<b>Sélectionner les garanties affectées</b>} name="garanties">
                <Checkbox.Group style={{ width: '100%' }} onChange={setSelectedGaranties}>
                    <Row gutter={[16, 16]}>
                        {garanties?.map(g => (
                            <Col xs={24} sm={12} key={g.value}>
                                <Checkbox value={g.value} style={{ fontSize: 15 }}>
                                    <span style={{ background: '#dbeafe', padding: '2px 8px', borderRadius: 4, marginRight: 8, fontSize: 12, fontWeight: 600 }}>{g.code}</span>
                                    {g.label.startsWith('RC') ? 'Responsabilité Civile' : g.label}
                                </Checkbox>
                            </Col>
                        ))}
                    </Row>
                </Checkbox.Group>
            </Form.Item>
        </div>

        {/* Bilan corporel */}
        {(typeSinistre === 'CORPOREL' || typeSinistre === 'MIXTE') && (
            <div style={{ background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)', padding: 16, borderRadius: 12, marginBottom: 20 }}>
                <h4 style={{ color: '#c62828', marginBottom: 16 }}>🏥 Bilan Corporel</h4>
                <Row gutter={16}>
                    <Col xs={12} md={6}><Form.Item label={<b>Blessés légers</b>} name="nbBlessesLegers"><InputNumber min={0} style={{ width: '100%' }} onChange={calculateEvaluation} /></Form.Item></Col>
                    <Col xs={12} md={6}><Form.Item label={<b>Blessés moyens</b>} name="nbBlessesMoyens"><InputNumber min={0} style={{ width: '100%' }} onChange={calculateEvaluation} /></Form.Item></Col>
                    <Col xs={12} md={6}><Form.Item label={<b>Blessés graves</b>} name="nbBlessesGraves"><InputNumber min={0} style={{ width: '100%' }} onChange={calculateEvaluation} /></Form.Item></Col>
                    <Col xs={12} md={6}><Form.Item label={<b>Décès</b>} name="nbDeces"><InputNumber min={0} style={{ width: '100%' }} onChange={calculateEvaluation} /></Form.Item></Col>
                </Row>
            </div>
        )}

        {/* Dégâts matériels */}
        {(typeSinistre === 'MATERIEL' || typeSinistre === 'MIXTE') && (
            <div style={{ background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)', padding: 16, borderRadius: 12, marginBottom: 20 }}>
                <h4 style={{ color: '#e65100', marginBottom: 16 }}>🔧 Dégâts Matériels</h4>
                <Form.Item label={<b>Type de dégâts matériels</b>} name="typeDegatsMateriels">
                    <Select style={{ width: '100%' }} placeholder="Sélectionner" onChange={calculateEvaluation}>
                        <Option value="LEGERS">Dégâts légers / Sans précision</Option>
                        <Option value="MOYENS">Dégâts moyens</Option>
                        <Option value="IMPORTANTS">Dégâts importants</Option>
                        <Option value="EXTREMES">Cas extrêmes</Option>
                    </Select>
                </Form.Item>
            </div>
        )}

        {/* Évaluation */}
        <div style={{ background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)', padding: 20, borderRadius: 12, marginBottom: 20 }}>
            <Row gutter={16} align="middle">
                <Col xs={24} sm={12}>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>💰 Évaluation Initiale</div>
                    <div style={{ fontSize: 32, fontWeight: 'bold', color: '#1b5e20' }}>{displayNumbers(evaluationInitiale)} FCFA</div>
                    <Button type="link" onClick={calculateEvaluation} style={{ padding: 0, marginTop: 8 }}>Recalculer automatiquement</Button>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>Ajuster l'évaluation</b>} name="evaluationInitiale">
                        <InputNumber min={0} style={{ width: '100%' }} value={evaluationInitiale}
                            formatter={v => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                            parser={v => v.replace(/\s?/g, '')}
                            addonAfter="FCFA" />
                    </Form.Item>
                </Col>
            </Row>
        </div>

        <Divider />
        <VictimesSection victimes={victimes} setVictimes={setVictimes}
            autoVictimes={autoVictimes} professions={professions}
            contrat={selectedContratObj} adversaires={adversaires} />
    </Card>
);

export default VictimesStep;
